module.exports = __webpack_public_path__ + "img/10.2ea08849.svg";